// extracted by mini-css-extract-plugin
module.exports = {"nav":"CoverNav_nav_oAE7b","locale":"CoverNav_locale_3V-h7","install":"CoverNav_install_29MeL","prompt":"CoverNav_prompt_3pUOC"};